export default __webpack_public_path__ + "static/media/glowa_gadanew.f6899ba3.gif";